import { atomWithReset } from 'jotai/utils';

interface LoginStateProps {
  socialToken: string | undefined;
  socialType: string | undefined;
  socialLastName: string | undefined;
  socialFullName: string | undefined;
  socialFirstName: string | undefined;
  socialLoginLanguage: string | undefined;
  socialEmail: string | undefined;
}

/**
 * Login store: due to Vue application has 2 ways data flow, it is hard to replicate the logic
 * similar to Vue, so I decided to create this login store for more than 1 way data flow.
 */
export const state = atomWithReset<LoginStateProps>({
  socialToken: '',
  socialType: '',
  socialLastName: '',
  socialFullName: '',
  socialFirstName: '',
  socialLoginLanguage: '',
  socialEmail: '',
});
